import React from 'react';
import { CTABlock } from './CTABlock';
export function HeroSection() {
  return <section className="bg-chocolate-900 text-chocolate-50 pt-16 pb-16 px-4 md:pt-20 md:pb-24" data-id="element-121">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-122">
        <div className="space-y-8 text-center md:text-left" data-id="element-123">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-124">
            Controlá tu ansiedad por el dulce en 21 días...{' '}
            <span className="text-gold-400" data-id="element-125">
              comiendo alfajores, helado y chocolate todos los días.
            </span>
          </h1>

          {/* Mockup - visible only on mobile, between title and subtitle */}
          <div className="flex justify-center md:hidden" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/wryWuUseiTipAJwCNbcZvi/Mockup.png" alt="Método Antídoto Dulce Mockup" className="w-full max-w-sm drop-shadow-2xl animate-fade-in-up" data-id="element-127" />
          </div>

          <p className="text-lg md:text-xl text-chocolate-50/90 leading-relaxed font-bold" data-id="element-128">
            El sistema proteico que hackea el mecanismo del antojo y convierte
            el dulce en tu mejor aliado. Sin dietas. Sin privaciones. Sin
            empezar de nuevo el lunes.
          </p>

          <div className="pt-4 flex justify-center md:justify-start" data-id="element-129">
            <CTABlock className="w-full md:w-auto text-lg" data-id="element-130">
              QUIERO EL SISTEMA COMPLETO
            </CTABlock>
          </div>
        </div>

        {/* Mockup - visible only on desktop */}
        <div className="hidden md:flex justify-center" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/wryWuUseiTipAJwCNbcZvi/Mockup.png" alt="Método Antídoto Dulce Mockup" className="w-full max-w-full drop-shadow-2xl animate-fade-in-up" data-id="element-132" />
        </div>
      </div>
    </section>;
}